import React, { useState } from "react";
import "./css/Governance.scss";

// Components

import TitleBox from "../components/TitleBox";
import Footer from "../components/Footer";
import Accordion from "../components/Accordion";

// Files

import file_1 from "../assets/pdf/GHSI Manual on Corporate Governance.pdf";
import file_2 from "../assets/pdf/GHSI Board Charter.pdf";
import file_3 from "../assets/pdf/GHSI Board Diversity Policy.pdf";
import file_4 from "../assets/pdf/GHSI Succession and Remuneration Policy.pdf";
import file_5 from "../assets/pdf/GHSI Nomination and Election Policy.pdf";
import file_6 from "../assets/pdf/GHSI Related Party Transaction Policy.pdf";
import file_7 from "../assets/pdf/GHSI Performance Assessment of Management Team Policy.pdf";
import file_8 from "../assets/pdf/GHSI Employee Feedback Guideline.pdf";
import file_9 from "../assets/pdf/GHSI Internal Control Guideline for Conflict of Interest.pdf";
import file_10 from "../assets/pdf/GHSI Internal Audit Charter.pdf";
import file_11 from "../assets/pdf/GHSI Audit Committee Charter.pdf";
import file_12 from "../assets/pdf/GHSI Corporate Governance Charter.pdf";
import file_13 from "../assets/pdf/GHSI Risk Oversight Charter.pdf";
import file_14 from "../assets/pdf/GHSI Related Party Transaction Charter.pdf";
import file_15 from "../assets/pdf/GHSI Independent Director Policy.pdf";
import file_16 from "../assets/pdf/GHSI Annual Performance Assessment Guidelines.pdf";
import file_17 from "../assets/pdf/GHSI Code of Business Conduct and Ethics.pdf";
import file_18 from "../assets/pdf/GHSI Disclosure Policy.pdf";
import file_19 from "../assets/pdf/GHSI Guideline for the Selection Process of External Auditor.pdf";
import file_20 from "../assets/pdf/GHSI Non Audit Services Policy.pdf";
import file_21 from "../assets/pdf/GHSI Shareholders' Policies and Programs Guideline.pdf";
import file_22 from "../assets/pdf/GHSI Anti-Bribery Guidelines.pdf";
import file_23 from "../assets/pdf/GHSI Whistle-Blowing Policy.pdf";
import file_24 from "../assets/pdf/GHSI Anti-Corruption Policy.pdf";
import file_25 from "../assets/pdf/GHSI_Retirement_Policy.pdf";

import file_26 from "../assets/pdf/Amended Articles of Incorporation.pdf";

// Curriculum Vitaes
import file_27 from "../assets/pdf/curriculum_vitae/CV-RYS.pdf";
import file_28 from "../assets/pdf/curriculum_vitae/CV-LSS.pdf";
import file_29 from "../assets/pdf/curriculum_vitae/CV-KLS.pdf";
import file_30 from "../assets/pdf/curriculum_vitae/CV-MMP.pdf";
import file_31 from "../assets/pdf/curriculum_vitae/CV-BPCC.pdf";
import file_32 from "../assets/pdf/curriculum_vitae/CV-JRS.pdf";
import file_33 from "../assets/pdf/curriculum_vitae/CV-RJP.pdf";

// By Laws
import file_34 from "../assets/pdf/Getwell Ammended By Laws.pdf";

// AFS
import file_35 from "../assets/pdf/2020 Audited Financial Statement.pdf";
import file_36 from "../assets/pdf/2020-2021 Annual Financial Statement.pdf";
import file_37 from "../assets/pdf/2022 Audited Financial Statement (GHSI).pdf";
import file_38 from "../assets/pdf/1. AFS_Getwell Health SystemsInc_12312023 ending December 2023.pdf";

// GIS
import file_39 from "../assets/pdf/2016 GENERAL INFORMATION SHEET (GIS).pdf";
import file_40 from "../assets/pdf/2017 GENERAL INFORMATION SHEET (GIS).pdf";
import file_41 from "../assets/pdf/2018 GENERAL INFORMATION SHEET (GIS).pdf";
import file_42 from "../assets/pdf/2019 GENERAL INFORMATION SHEET (GIS).pdf";
import file_43 from "../assets/pdf/2020 GENERAL INFORMATION SHEET (GIS).pdf";
import file_44 from "../assets/pdf/General Information Sheet (GIS to 2021).pdf";
import file_45 from "../assets/pdf/GIS(GENERAL INFO. SHEET) 2022.pdf";
import file_46 from "../assets/pdf/GHSI Filed 2023 GIS.pdf";
import file_47 from "../assets/pdf/2024 GIS _ GHSI with SEC Acceptance.pdf";

// Stockholder Meeting Minutes
import file_48 from "../assets/pdf/Directors' Certificate to Mr Johnny G De Leon (Cubao Branch).pdf";
import file_49 from "../assets/pdf/Directors' Certificate to Mr Rolando M Berin (GenSan branch).pdf";
import file_50 from "../assets/pdf/Director's Certificate to Ms Annaliza H Lumanglas ( Batangas Branch ).pdf";
import file_51 from "../assets/pdf/Directors' Certificate to Ms Annaliza H Lumanglas ( Bauan Branch ).pdf";
import file_52 from "../assets/pdf/Directors' Certificate to Ms Divinia A Segui ( Calamba Branch ).pdf";
import file_53 from "../assets/pdf/Directors' Certificate to Ms Divinia A Segui ( Lipa Branch ).pdf";
import file_54 from "../assets/pdf/Director's Certificate to Ms Nelsa C Arrojado (Cebu branch).pdf";

import file_55 from "../assets/pdf/BOD Minutes of Meeting 2020/BOD Regular Meeting January 17, 2020.pdf";
import file_56 from "../assets/pdf/BOD Minutes of Meeting 2020/BOD Regular Meeting February 17, 2020.pdf";
import file_57 from "../assets/pdf/BOD Minutes of Meeting 2020/BOD Regular Meeting June 30, 2020.pdf";
import file_58 from "../assets/pdf/BOD Minutes of Meeting 2020/BOD Special Meeting July 20, 2020.pdf";
import file_59 from "../assets/pdf/BOD Minutes of Meeting 2020/BOD Regular Meeting September 04, 2020.pdf";
import file_60 from "../assets/pdf/BOD Minutes of Meeting 2020/BOD Special Meeting November 06, 2020.pdf";
import file_61 from "../assets/pdf/BOD Minutes of Meeting 2020/BOD Regular Meeting December 14, 2020.pdf";

import file_62 from "../assets/pdf/BOD Minutes of Meeting 2021/BOD Special Meeting 20 January 2021.pdf";
import file_63 from "../assets/pdf/BOD Minutes of Meeting 2021/BOD Special Meeting 22 January 2021.pdf";
import file_64 from "../assets/pdf/BOD Minutes of Meeting 2021/BOD Regular Meeting 16 February 2021.pdf";
import file_65 from "../assets/pdf/BOD Minutes of Meeting 2021/BOD Special Meeting 16 March 2021.pdf";
import file_66 from "../assets/pdf/BOD Minutes of Meeting 2021/BOD Special Meeting 07 April 2021.pdf";
import file_67 from "../assets/pdf/BOD Minutes of Meeting 2021/BOD Special Meeting 13 April 2021.pdf";
import file_68 from "../assets/pdf/BOD Minutes of Meeting 2021/BOD Regular Meeting 12 May 2021.pdf";
import file_69 from "../assets/pdf/BOD Minutes of Meeting 2021/BOD Regular Meeting 26 May 2021.pdf";
import file_70 from "../assets/pdf/BOD Minutes of Meeting 2021/BOD Special Meeting 28 May 2021.pdf";
import file_71 from "../assets/pdf/BOD Minutes of Meeting 2021/BOD Regular Meeting 17 June 2021.pdf";
import file_72 from "../assets/pdf/BOD Minutes of Meeting 2021/BOD Regular Meeting 20 August 2021.pdf";
import file_73 from "../assets/pdf/BOD Minutes of Meeting 2021/BOD Regular Meeting 02 September 2021.pdf";
import file_74 from "../assets/pdf/BOD Minutes of Meeting 2021/BOD Regular Meeting 10 November 2021.pdf";

import file_75 from "../assets/pdf/BOD Minutes of Meeting 2022/GHSI Regular Board Minutes 12 January 2022.pdf";
import file_76 from "../assets/pdf/BOD Minutes of Meeting 2022/GHSI Regular Board Minutes 16 February.pdf";
import file_77 from "../assets/pdf/BOD Minutes of Meeting 2022/GHSI Regular Board Minutes 16 March 2022.pdf";
import file_78 from "../assets/pdf/BOD Minutes of Meeting 2022/GHSI Special Board Minutes 8 July 2022.pdf";
import file_79 from "../assets/pdf/BOD Minutes of Meeting 2022/GHSI Special Board Minutes 20 July 2022.pdf";
import file_80 from "../assets/pdf/BOD Minutes of Meeting 2022/GHSI Regular Board Minutes 21 July 2022.pdf";
import file_81 from "../assets/pdf/BOD Minutes of Meeting 2022/GHSI Special Board Minutes 24 August 2022.pdf";
import file_82 from "../assets/pdf/BOD Minutes of Meeting 2022/GHSI Regular Board Minutes 19 September 2023.pdf";
import file_83 from "../assets/pdf/BOD Minutes of Meeting 2022/GHSI Regular Board Minutes 11 October 2022.pdf";
import file_84 from "../assets/pdf/BOD Minutes of Meeting 2022/GHSI Special Board Minutes 9 December.pdf";

import file_85 from "../assets/pdf/BOD Minutes of Meeting 2024/01.19.24 Minutes of the Special Meeting of the BOD.pdf";
import file_86 from "../assets/pdf/BOD Minutes of Meeting 2024/02.15.24 Minutes of the Special Meeting of the BOD.pdf";
import file_87 from "../assets/pdf/BOD Minutes of Meeting 2024/04.11.24 Minutes of the Regular Meeting.pdf";
import file_88 from "../assets/pdf/BOD Minutes of Meeting 2024/04.26.24 Minutes of the Special Meeting of the BOD.pdf";
import file_89 from "../assets/pdf/BOD Minutes of Meeting 2024/06.20.24 Minutes of the Meeting of the BOD.pdf";
import file_90 from "../assets/pdf/BOD Minutes of Meeting 2024/07.11.24 Minutes of the Special Meeting of the BOD.pdf";
import file_91 from "../assets/pdf/BOD Minutes of Meeting 2024/07.25.24 Minutes of the Regular Meeting of the BOD.pdf";
import file_92 from "../assets/pdf/BOD Minutes of Meeting 2024/08.16.2024 Minutes of the Special Meeting.pdf";
import file_93 from "../assets/pdf/BOD Minutes of Meeting 2024/08.28.24 Minutes of the Meeting of the BOD.pdf";
import file_94 from "../assets/pdf/BOD Minutes of Meeting 2024/10.17.24 Minutes of the Regular Meeting of the BOD.pdf";
import file_95 from "../assets/pdf/BOD Minutes of Meeting 2024/11.15.24 Minutes of the Regular Meeting of the BOD.pdf";
import file_96 from "../assets/pdf/BOD Minutes of Meeting 2024/11.20.24 - Minutes of the Regular Meeting of the BOD.pdf";
import file_97 from "../assets/pdf/BOD Minutes of Meeting 2024/12.18.24 Minutes of the Regular Meeting of the BOD.pdf";

// ASM
import file_98 from "../assets/pdf/Notice of the ASM 2021/Notice of Annual Shareholder's Meeting 2021.pdf";
import file_99 from "../assets/pdf/Notice of the ASM 2021/Procedures for Participating in the Stockholdr's Meeting via remote communication or in absentia.pdf";
import file_100 from "../assets/pdf/Notice of the ASM 2022/GHSI Notice ASM 22 March 2022.pdf";
import file_101 from "../assets/pdf/Notice of the ASM 2023/2023- GHSI Notice of Annual Stockholders Meeting.pdf";

import file_102 from "../assets/pdf/Minutes of the ASM 2021/BOD Special Organizational Meeting 05 March 2021.pdf";
import file_103 from "../assets/pdf/Minutes of the ASM 2021/Minutes of the Annual Shareholder's Meeting 05 March 2021.pdf";
import file_104 from "../assets/pdf/Minutes of the ASM 2023/2023-GHSI-Annual Stockholders Meeting Minutes.pdf";

import file_105 from "../assets/pdf/Notice of the ASM 2024/2024 - GHSI Notice of Annual Stockholders Meeting.pdf";
import file_106 from "../assets/pdf/Minutes of the ASM 2024/2024-GHSI Annual Stockholders Meeting Minutes.pdf";

// ACGR
import file_107 from "../assets/pdf/2020 Annual Corporate Governance Report (SCORE CARD).pdf";
import file_108 from "../assets/pdf/2021 Annual Corporate Governance Report (ACGR) Scorecard.pdf";
import file_109 from "../assets/pdf/acgr_scorecards/ACGR SCORECARD for 2024.pdf";

// ASM
import file_110 from "../assets/pdf/Minutes of the ASM 2024/04.26.24 Minutes of the Annual Shareholdings' Meeting.pdf";

// Stockholder Meeting Minutes
import file_111 from "../assets/pdf/BOD Minutes of Meeting 2024/04.26.24 Minutes of the Organizational Meeting of the BOD.pdf";

// ACGR
import file_112 from "../assets/pdf/acgr_scorecards/ACGR SCORECARD for 2022.pdf";
import file_113 from "../assets/pdf/acgr_scorecards/ACGR SCORECARD for 2023.pdf";

// Stockholder Meeting Minutes
import file_114 from "../assets/pdf/BOD Minutes of Meeting 2022/MINUTES OF ANNUAL SHAREHOLDERS MEETING 20 April 2022.pdf";
import file_115 from "../assets/pdf/BOD Minutes of Meeting 2022/ORGANIZATIONAL MEETING OF BOD 20 April 2022.pdf";

import file_116 from "../assets/pdf/GHSI - 2025 GIS SEC Final Acceptance.pdf";

import file_117 from "../assets/pdf/2025 Scanned MINUTES ANNUAL SHAREHOLDERS MTG 4.11.25.pdf";
import file_118 from "../assets/pdf/2025 ORG MINUTES 04.11.25.pdf";
import file_119 from "../assets/pdf/08.01.25 Minutes Spcl Mtg.pdf";

import file_120 from "../assets/pdf/BOD Minutes of Meeting 2025/01.15.25 Minutes spcl mtg .pdf";
import file_121 from "../assets/pdf/BOD Minutes of Meeting 2025/01.23.25 Minutes Reg Mtg.pdf";
import file_122 from "../assets/pdf/BOD Minutes of Meeting 2025/01.27.25 Minutes Reg Mtg.pdf";
import file_123 from "../assets/pdf/BOD Minutes of Meeting 2025/02.20.25 Minutes Reg Mtg.pdf";
import file_124 from "../assets/pdf/BOD Minutes of Meeting 2025/02.26.25 Minutes Reg Mtg.pdf";
import file_125 from "../assets/pdf/BOD Minutes of Meeting 2025/03.19.25 Minutes Reg Mtg.pdf";
import file_126 from "../assets/pdf/BOD Minutes of Meeting 2025/06.18.25 Minutes Spcl Mtg.pdf";
import file_127 from "../assets/pdf/BOD Minutes of Meeting 2025/06.24.25 Minutes Spcl Mtg.pdf";
import file_128 from "../assets/pdf/BOD Minutes of Meeting 2025/07.15.25 Minutes Spcl Mtg.pdf";
import file_129 from "../assets/pdf/BOD Minutes of Meeting 2025/07.17.25 Minutes Reg Mtg.pdf";
import file_130 from "../assets/pdf/BOD Minutes of Meeting 2025/08.01.25 Minutes Spcl Mtg.pdf";
import file_131 from "../assets/pdf/BOD Minutes of Meeting 2025/08.22.25 Minutes Reg Mtg.pdf";
import file_132 from "../assets/pdf/BOD Minutes of Meeting 2025/09.23.25 Minutes Reg Mtg.pdf";
import file_133 from "../assets/pdf/BOD Minutes of Meeting 2025/10.21.25 Minutes Reg Mtg.pdf";
import file_134 from "../assets/pdf/BOD Minutes of Meeting 2025/12.16.25 Minutes Reg Mtg.pdf";

import file_135 from "../assets/pdf/acgr_scorecards/2025 Annual Corporate Governance Report (ACGR) Scorecard.pdf";

import file_136 from "../assets/pdf/GHSI AFS 2025.pdf";

import file_138 from "../assets/pdf/GHSI AFS 2024 W BIR Stamped SEC received (F).pdf";

const curriculumVitaes = [
  {
    name: "Atty. Rene Y. Soriano",
    file: file_27,
  },
  {
    name: "Lea S. Soriano",
    file: file_28,
  },
  {
    name: "Atty. Kathryn Leia S. Soriano-Posadas",
    file: file_29,
  },
  {
    name: "Ms. Merlita M. Primo",
    file: file_30,
  },
  {
    name: "Atty. Bernard Philip C. Claustro",
    file: file_31,
  },
  {
    name: "Mr. Josef Ryan S. Soriano",
    file: file_32,
  },
  {
    name: "Mr. Reynato J. Primo",
    file: file_33,
  },
];

const governancePolicies = [
  {
    name: "GHSI Manual on Corporate Governance",
    file: file_1,
  },
  {
    name: "GHSI Board Charter",
    file: file_2,
  },
  {
    name: "GHSI Board Diversity Policy",
    file: file_3,
  },
  {
    name: "GHSI Succession and Remuneration Policy",
    file: file_4,
  },
  {
    name: "GHSI Nomination and Election Policy",
    file: file_5,
  },
  {
    name: "GHSI Related Party Transaction Policy",
    file: file_6,
  },
  {
    name: "GHSI Performance Assessment of Management Team Policy",
    file: file_7,
  },
  {
    name: "GHSI Employee Feedback Guideline",
    file: file_8,
  },
  {
    name: "GHSI Internal Control Guideline for Conflict of Interest",
    file: file_9,
  },
  {
    name: "GHSI Internal Audit Charter",
    file: file_10,
  },
  {
    name: "GHSI Audit Committee Charter",
    file: file_11,
  },
  {
    name: "GHSI Corporate Governance Charter",
    file: file_12,
  },
  {
    name: "GHSI Risk Oversight Charter",
    file: file_13,
  },
  {
    name: "GHSI Related Party Transaction Charter",
    file: file_14,
  },
  {
    name: "GHSI Independent Director Policy",
    file: file_15,
  },
  {
    name: "GHSI Annual Performance Assessment Guidelines",
    file: file_16,
  },
  {
    name: "GHSI Code of Business Conduct and Ethics",
    file: file_17,
  },
  {
    name: "GHSI Disclosure Policy",
    file: file_18,
  },
  {
    name: "GHSI Guideline for the Selection Process of External Auditor",
    file: file_19,
  },
  {
    name: "GHSI Non Audit Services Policy",
    file: file_20,
  },
  {
    name: "GHSI Shareholders' Policies and Programs Guideline",
    file: file_21,
  },
  {
    name: "GHSI Anti-Bribery Guidelines",
    file: file_22,
  },
  {
    name: "GHSI Whistle-Blowing Policy",
    file: file_23,
  },
  {
    name: "GHSI Anti-Corruption Policy",
    file: file_24,
  },
  {
    name: "GHSI RetirementPolicy",
    file: file_25,
  },
];

const incorporations = [
  {
    name: "Articles of Incorporation",
    file: file_26,
  },
];

const byLaws = [
  {
    name: "Amended By-Laws",
    file: file_34,
  },
];

const AFSData = [
  {
    name: "Financial Reports for the year ended December 31, 2019 and 2020",
    file: file_35,
  },
  {
    name: "Financial Reports for the year ended December 31, 2020 and 2021",
    file: file_36,
  },
  {
    name: "Financial Reports for the year ended December 31, 2021 and 2022",
    file: file_37,
  },
  {
    name: "Financial Reports for the year ended December 31, 2022 and 2023",
    file: file_38,
  },
  {
    name: "Financial Reports for the year ended December 31, 2024",
    file: file_138,
  },
  {
    name: "Financial Reports for the year ended December 31, 2025",
    file: file_136,
  },
];

const GISData = [
  {
    name: "General Information Sheet (GIS-2016)",
    file: file_39,
  },
  {
    name: "General Information Sheet (GIS-2017)",
    file: file_40,
  },
  {
    name: "General Information Sheet (GIS-2018)",
    file: file_41,
  },
  {
    name: "General Information Sheet (GIS-2019)",
    file: file_42,
  },
  {
    name: "General Information Sheet (GIS-2020)",
    file: file_43,
  },
  {
    name: "General Information Sheet (GIS-2021)",
    file: file_44,
  },
  {
    name: "General Information Sheet (GIS-2022)",
    file: file_45,
  },
  {
    name: "General Information Sheet (GIS-2023)",
    file: file_46,
  },
  {
    name: "General Information Sheet (GIS-2024)",
    file: file_47,
  },
  {
    name: "General Information Sheet (GIS-2025)",
    file: file_116,
  },
];

const stockholderMeetingMinutes = [
  {
    name: "Directors' Certificate to Mr. Johnny G. De Leon (Cubao Branch)",
    file: file_48,
    content: "",
  },
  {
    name: "Directors' Certificate to Mr. Rolando M. Berin (GenSan branch)",
    file: file_49,
    content: "",
  },
  {
    name: "Director's Certificate to Ms. Annaliza H. Lumanglas (Batangas Branch)",
    file: file_50,
    content: "",
  },
  {
    name: "Directors' Certificate to Ms. Annaliza H. Lumanglas (Bauan Branch)",
    file: file_51,
    content: "",
  },
  {
    name: "Directors' Certificate to Ms. Divinia A. Segui (Calamba Branch)",
    file: file_52,
    content: "",
  },
  {
    name: "Directors' Certificate to Ms. Divinia A. Segui (Lipa Branch)",
    file: file_53,
    content: "",
  },
  {
    name: "Director's Certificate to Ms. Nelsa C. Arrojado (Cebu branch)",
    file: file_54,
    content: "",
  },
  {
    name: "BOD Regular Meeting January 17, 2020",
    file: file_55,
  },
  {
    name: "BOD Regular Meeting February 17, 2020",
    file: file_56,
  },
  {
    name: "BOD Regular Meeting June 30, 2020",
    file: file_57,
  },
  {
    name: "BOD Special Meeting July 20, 2020",
    file: file_58,
  },
  {
    name: "BOD Regular Meeting September 04, 2020",
    file: file_59,
  },
  {
    name: "BOD Special Meeting November 06, 2020",
    file: file_60,
  },
  {
    name: "BOD Regular Meeting December 14, 2020",
    file: file_61,
  },
  {
    name: "BOD Special Meeting 20 January 2021",
    file: file_62,
  },
  {
    name: "BOD Special Meeting 22 January 2021",
    file: file_63,
  },
  {
    name: "BOD Regular Meeting 16 February 2021",
    file: file_64,
  },
  {
    name: "BOD Special Meeting 16 March 2021",
    file: file_65,
  },
  {
    name: "BOD Special Meeting 07 April 2021",
    file: file_66,
  },
  {
    name: "BOD Special Meeting 13 April 2021.pdf",
    file: file_67,
  },
  {
    name: "BOD Regular Meeting 12 May 2021.pdf",
    file: file_68,
  },
  {
    name: "BOD Regular Meeting 26 May 2021.pdf",
    file: file_69,
  },
  {
    name: "BOD Special Meeting 28 May 2021.pdf",
    file: file_70,
  },
  {
    name: "BOD Regular Meeting 17 June 2021.pdf",
    file: file_71,
  },
  {
    name: "BOD Regular Meeting 20 August 2021.pdf",
    file: file_72,
  },
  {
    name: "BOD Regular Meeting 02 September 2021.pdf",
    file: file_73,
  },
  {
    name: "BOD Regular Meeting 10 November 2021.pdf",
    file: file_74,
  },
  {
    name: "GHSI Regular Board Minutes 12 January 2022.pdf",
    file: file_75,
  },
  {
    name: "GHSI Regular Board Minutes 16 February.pdf",
    file: file_76,
  },
  {
    name: "GHSI Regular Board Minutes 16 March 2022.pdf",
    file: file_77,
  },
  {
    name: "MINUTES OF ANNUAL SHAREHOLDERS MEETING 20 April 2022.pdf",
    file: file_114,
  },
  {
    name: "ORGANIZATIONAL MEETING OF BOD 20 April 2022.pdf",
    file: file_115,
  },
  {
    name: "GHSI Special Board Minutes 8 July 2022.pdf",
    file: file_78,
  },
  {
    name: "GHSI Special Board Minutes 20 July 2022.pdf",
    file: file_79,
  },
  {
    name: "GHSI Regular Board Minutes 21 July 2022.pdf",
    file: file_80,
  },
  {
    name: "GHSI Special Board Minutes 24 August 2022.pdf",
    file: file_81,
  },
  {
    name: "GHSI Regular Board Minutes 19 September 2023.pdf",
    file: file_82,
  },
  {
    name: "GHSI Regular Board Minutes 11 October 2022.pdf",
    file: file_83,
  },
  {
    name: "GHSI Special Board Minutes 9 December.pdf",
    file: file_84,
  },
  {
    name: "01.19.24 Minutes of the Special Meeting of the BOD.pdf",
    file: file_85,
  },
  {
    name: "02.15.24 Minutes of the Special Meeting of the BOD.pdf",
    file: file_86,
  },
  {
    name: "04.11.24 Minutes of the Regular Meeting.pdf",
    file: file_87,
  },
  {
    name: "04.26.24 Minutes of the Special Meeting of the BOD.pdf",
    file: file_88,
  },
  {
    name: "06.20.24 Minutes of the Meeting of the BOD.pdf",
    file: file_89,
  },
  {
    name: "07.11.24 Minutes of the Special Meeting of the BOD.pdf",
    file: file_90,
  },
  {
    name: "07.25.24 Minutes of the Regular Meeting of the BOD.pdf",
    file: file_91,
  },
  {
    name: "08.16.2024 Minutes of the Special Meeting.pdf",
    file: file_92,
  },
  {
    name: "08.28.24 Minutes of the Meeting of the BOD.pdf",
    file: file_93,
  },
  {
    name: "10.17.24 Minutes of the Regular Meeting of the BOD.pdf",
    file: file_94,
  },
  {
    name: "11.15.24 Minutes of the Regular Meeting of the BOD.pdf",
    file: file_95,
  },
  {
    name: "11.20.24 - Minutes of the Regular Meeting of the BOD.pdf",
    file: file_96,
  },
  {
    name: "12.18.24 Minutes of the Regular Meeting of the BOD.pdf",
    file: file_97,
  },
  {
    name: "04.26.24 Minutes of the Organizational Meeting of the BOD.pdf",
    file: file_111,
  },
  {
    name: "01.15.25 Minutes spcl mtg .pdf",
    file: file_120,
  },
  {
    name: "01.23.25 Minutes Reg Mtg.pdf",
    file: file_121,
  },
  {
    name: "01.27.25 Minutes Reg Mtg.pdf",
    file: file_122,
  },
  {
    name: "02.20.25 Minutes Reg Mtg.pdf",
    file: file_123,
  },
  {
    name: "02.26.25 Minutes Reg Mtg.pdf",
    file: file_124,
  },
  {
    name: "03.19.25 Minutes Reg Mtg.pdf",
    file: file_125,
  },
  {
    name: "06.18.25 Minutes Spcl Mtg.pdf",
    file: file_126,
  },
  {
    name: "06.24.25 Minutes Spcl Mtg.pdf",
    file: file_127,
  },
  {
    name: "07.15.25 Minutes Spcl Mtg.pdf",
    file: file_128,
  },
  {
    name: "07.17.25 Minutes Reg Mtg.pdf",
    file: file_129,
  },
  {
    name: "08.01.25 Minutes Spcl Mtg.pdf",
    file: file_130,
  },
  {
    name: "08.22.25 Minutes Reg Mtg.pdf",
    file: file_131,
  },
  {
    name: "09.23.25 Minutes Reg Mtg.pdf",
    file: file_132,
  },
  {
    name: "10.21.25 Minutes Reg Mtg.pdf",
    file: file_133,
  },
  {
    name: "12.16.25 Minutes Reg Mtg.pdf",
    file: file_134,
  },
];

const ASMData = [
  {
    name: "Notice of Annual Shareholder's Meeting 2021",
    file: file_98,
  },
  {
    name: "Procedures for Participating in the Stockholder's Meeting via remote communication or in absentia",
    file: file_99,
  },
  {
    name: "Notice of Annual Shareholder's Meeting 2022",
    file: file_100,
  },
  {
    name: "Notice of Annual Shareholder's Meeting 2023",
    file: file_101,
  },
  {
    name: "BOD Special Organizational Meeting 05 March 2021",
    file: file_102,
  },
  {
    name: "Minutes of the Annual Shareholder's Meeting 05 March 2021",
    file: file_103,
  },
  {
    name: "Minutes of the Annual Shareholder's Meeting 30 March 2023",
    file: file_104,
  },
  {
    name: "Notice of Annual Shareholder's Meeting 2024",
    file: file_105,
  },
  {
    name: "2024 Minutes of Meeting of the Annual Shareholder's Meeting",
    file: file_106,
    content: "",
  },
  {
    name: "04.26.24 Minutes of the Annual Shareholdings' Meeting.pdf",
    file: file_110,
    content: "",
  },
  {
    name: "2025 Scanned MINUTES ANNUAL SHAREHOLDERS MTG 4.11.25.pdf",
    file: file_117,
  },
  {
    name: "2025 ORG MINUTES 04.11.25.pdf",
    file: file_118,
  },
  {
    name: "08.01.25 Minutes Spcl Mtg.pdf",
    file: file_119,
  },
];

const ACGRData = [
  {
    name: "2020 Annual Corporate Governance Report (ACGR) Scorecard",
    file: file_107,
  },
  {
    name: "2021 Annual Corporate Governance Report (ACGR) Scorecard",
    file: file_108,
  },
  {
    name: "2022 Annual Corporate Governance Report (ACGR) Scorecard",
    file: file_112,
  },
  {
    name: "2023 Annual Corporate Governance Report (ACGR) Scorecard",
    file: file_113,
  },
  {
    name: "2024 Annual Corporate Governance Report (ACGR) Scorecard",
    file: file_109,
  },
  {
    name: "2025 Annual Corporate Governance Report (ACGR) Scorecard.pdf",
    file: file_135,
  },
];

const governanceContents = [
  {
    name: "Governance Policies",
    file: "",
    content: governancePolicies,
  },
  {
    name: "Incorporations",
    file: "",
    content: incorporations,
  },
  {
    name: "By Laws",
    file: "",
    content: byLaws,
  },
  {
    name: "AFS",
    file: "",
    content: AFSData,
  },
  {
    name: "GIS",
    file: "",
    content: GISData,
  },
  {
    name: "Stockholder Meeting Minutes",
    file: "",
    content: stockholderMeetingMinutes,
  },
  {
    name: "ASM",
    file: "",
    content: ASMData,
  },
  {
    name: "ACGR Scorecard",
    file: "",
    content: ACGRData,
  },
  {
    name: "Board of Directors' Curricula Vitae",
    file: "",
    content: curriculumVitaes,
  },
];

const Governance = () => {
  const [height, setHeight] = useState(window.innerHeight);
  const [width, setWidth] = useState(window.innerWidth);

  window.addEventListener("resize", function () {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  });

  return (
    <div
      className="governance-container"
      style={{
        height: height - 75,
        width: width,
      }}
    >
      <TitleBox title={"Governance"} />
      <div className="governance-selection">
        <div className="inner-container">
          <div id="containerGovernance">
            {governanceContents.map((governanceContent, index) => {
              return (
                <React.Fragment key={index}>
                  <Accordion
                    name={governanceContent.name}
                    content={governanceContent.content}
                  />
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>
      <Footer
        args={{
          height,
          width,
          styles: {
            height: 50,
            width: width,
            position: "absolute",
            bottom: 0,
          },
        }}
      />
    </div>
  );
};

export default Governance;
